(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tfs-gk-relaunch-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-gk-approved-image]');
    if (!root) return;

    const approvedImage = root.dataset.gkApprovedImage;
    const approvedAlt = root.dataset.gkApprovedAlt;
    const displayTitle = root.dataset.gkDisplayTitle;
    const displaySubtitle = root.dataset.gkDisplaySubtitle;
    const personalizeLabel = root.dataset.gkPersonalizeLabel;
    const shippingLabel = root.dataset.gkShippingLabel;

    const applyApprovedImage = () => {
      document.querySelectorAll('main img').forEach((image) => {
        const alt = image.getAttribute('alt') || '';
        if (!alt.includes('Grandma’s Kitchen Masterpiece')) return;

        const picture = image.closest('picture');
        picture?.querySelectorAll('source').forEach((source) => source.removeAttribute('srcset'));
        image.removeAttribute('srcset');

        if (image.getAttribute('src') !== approvedImage) image.setAttribute('src', approvedImage);
        image.setAttribute('alt', approvedAlt);
        image.style.objectFit = 'contain';
        image.style.backgroundColor = '#f8f5ee';
      });
    };

    const applyDraftPresentation = () => {
      document.documentElement.classList.add('tfs-gk-relaunch-active');

      const heading = Array.from(document.querySelectorAll('main h1')).find((item) =>
        item.textContent.includes('Grandma’s Kitchen Masterpiece')
      );

      if (heading && !heading.querySelector('.tfs-gk-display-title')) {
        const title = document.createElement('span');
        title.className = 'tfs-gk-display-title';
        title.textContent = displayTitle;

        const subtitle = document.createElement('span');
        subtitle.className = 'tfs-gk-display-subtitle';
        subtitle.textContent = displaySubtitle;

        heading.replaceChildren(title, subtitle);
      }

      const price = document.querySelector('product-price[data-product-id="8305622941765"]');
      if (price && !price.parentElement?.querySelector('.tfs-gk-shipping-note')) {
        const shippingNote = document.createElement('p');
        shippingNote.className = 'tfs-gk-shipping-note';
        shippingNote.textContent = shippingLabel;
        price.insertAdjacentElement('afterend', shippingNote);
      }

      document
        .querySelectorAll('fieldset[data-option-id*="8305622941765-artwork-orientation"] input[type="radio"]')
        .forEach((input) => {
          const label = input.closest('label');
          const text = label?.querySelector('.variant-option__button-label__text');
          if (!text) return;

          const shortLabel = input.value.startsWith('Wide') ? 'Landscape' : 'Portrait';
          if (text.textContent !== shortLabel) text.textContent = shortLabel;
        });

      document.querySelectorAll('.js_apod_personalize_btn').forEach((button) => {
        button.dataset.gkLabel = personalizeLabel;
        button.setAttribute('aria-label', personalizeLabel);
      });
    };

    applyApprovedImage();
    applyDraftPresentation();

    const productMain = document.querySelector('main');
    if (productMain) {
      new MutationObserver(() => {
        applyApprovedImage();
        applyDraftPresentation();
      }).observe(productMain, {
        attributes: true,
        attributeFilter: ['src', 'srcset'],
        childList: true,
        subtree: true
      });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
